import { createFileRoute } from "@tanstack/react-router";
import { MediaPage } from "../../components/media";
import { MediaType } from "../../generated/graphql";

export const Route = createFileRoute("/media/files")({
  component: FilesPage,
});

function FilesPage() {
  return <MediaPage mediaType={MediaType.File} basePath="/media/files" />;
}
